import React from 'react';
import { Outlet } from 'react-router-dom';

import Tab from '../tabs/components/Tab';
import TabMenu from '../tabs/components/TabMenu';

import Map from '../map/components/Map';

import TopBar from './TopBar';
import { Image, Layers, Search, Tool } from 'react-feather';
import DetailsTab from '../tabs/components/DetailsTab';
import Tutorial from '../tutorial/components/Tutorial';
import AnnouncementModal from './AnnouncementModal';

const Layout: React.FC = () => {
  return (
    <div>
      {/* Announcement */ }
      <AnnouncementModal
        title="***Notice of Online Access Change - Effective March 16***"
        message={
          <>
            Beginning March 16, a free user login will be required to access County online
            platforms that display property address information, including GIS, Land Records,
            and Tax & Assessor services. This step helps protect public data and strengthen
            system security. You can create your free account today on{' '}
            <a href="https://www.horrycountysc.gov" target="_blank" rel="noopener noreferrer">
              www.horrycountysc.gov
            </a>{' '}
            to ensure uninterrupted access when the login requirement takes effect on March 16.
          </>
        }
      />
      <TopBar />

      <TabMenu>
        <Tab Icon={Layers} url='/legend' label="Legend Tab" />
        <Tab Icon={Image} url="/imagery" label="Imagery Tab"/>
        <Tab Icon={Search} url="/search" label="Search Tab"/>
        <DetailsTab />
        <Tab Icon={Tool} url="/tools" label="Tools Tab"/>
      </TabMenu>
      <Tutorial />
      <Outlet />

      <Map />
    </div>
  )
}

export default Layout;